import React, { useContext } from 'react';
import {StateContext, actions} from "../../state/index";
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { getImageSrcUrl } from "../../utils/images";
import { useTranslation } from 'react-i18next';
import ChooseLanguage from './ChooseLanguage';
import { languageOptions } from "../../utils/i18n";
import { BROWSER_STORAGE_ITEMS } from "../../utils/enums";
import { get } from 'lodash/object';

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0px 1em;
  overflow: hidden;
  z-index: 2;
  min-height: 60px;
  
  @media screen and (max-width: 500px) {
    padding: 0 0.5em;
  }
`;

export const HeaderSections = styled.div`
  height: 75%;
  align-items: center;
  display: flex;
  max-height: 75%;
  width: 100%;
  overflow: hidden;
`;

export const HeaderSection = styled.div`
  height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const HeaderLeft = styled(HeaderSection)`
  justify-content: flex-start;
`;

export const HeaderCenter = styled(HeaderSection)`
  justify-content: center;
`;

export const HeaderRight = styled(HeaderSection)`
  justify-content: flex-end;
`;

export const HeaderLogo = styled.img`
  max-height: 90%;
  max-width: 50vw;
  
  @media screen and (max-width: 500px) {
    max-width: 75vw;
  }
   &:hover {
    cursor: pointer;
  }
`;

export const Header = ({logoSrc, logoPosition = "left", reinitializeAppOnLogoClick = false}) => {
  const [{configuration}, dispatch] = useContext(StateContext); // eslint-disable-line no-empty-pattern
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars
  const selectedLanguage = i18n.language && languageOptions.filter(language => language.value === i18n.language)[0];
  const faqs = get(configuration, 'faqs', []);

  return (
    <StyledHeader id="header">
      <HeaderSections>
        <HeaderLeft>
          {logoPosition === 'left' && logoSrc && <HeaderLogo
            onClick={() => {
              if(reinitializeAppOnLogoClick) {
                window.sessionStorage.clear();
                window.localStorage.removeItem(BROWSER_STORAGE_ITEMS.SEEN_SYSTEM_NOTIFICATIONS);
                window.location.reload();
              }
            }}
            src={getImageSrcUrl(logoSrc)}
            title="Click to Start Over"
          />}
        </HeaderLeft>
        <HeaderCenter>
          {logoPosition === 'center' && logoSrc && <HeaderLogo src={getImageSrcUrl(logoSrc)} />}
        </HeaderCenter>
        <HeaderRight>
          {selectedLanguage && get(configuration, 'languageSelector.showLanguageSelector', false) && <div className="language-selector" onClick={() => {
            dispatch(actions.modals.pushModal(<ChooseLanguage allowClose={true}/>, {title: t('chooseLanguage'), className: 'language-selector-modal'}));
          }}>
            <span className="label">{i18n.t('language')} &#9662;</span>
          </div>}
          {faqs.length > 0 && <FontAwesomeIcon className="help-icon" icon={faQuestionCircle} size="lg" alt="help"  onClick={() => dispatch(actions.modals.showFaqs())}/>}
        </HeaderRight>
      </HeaderSections>
    </StyledHeader>
  );
};

export const ProgramHeader = () => {
  const [{configuration}] = useContext(StateContext);
  const {header} = configuration;

  return header && <Header {...header} />
};

export default Header;
